/**
 * Member/app-user split, phase 4b. A person who registered with no member record yet
 * signs in with a login their CG leader has not linked in Acts. hogc-one-api serves
 * them the routes it has converted and answers every other one with
 * 403 { code: 'LINK_REQUIRED' }.
 */
export const LINK_REQUIRED = 'LINK_REQUIRED';

export const LINK_REQUIRED_MESSAGE =
  'This will be available once your CG leader has linked your account.';

/**
 * @param {unknown} error an axios error
 * @returns {boolean} whether the API refused because the account is not linked yet
 */
export function isLinkRequired(error) {
  const response = error && typeof error === 'object' ? error.response : undefined;
  return response?.status === 403 && response?.data?.code === LINK_REQUIRED;
}
